var _defs, _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConduitFillIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "bg-navy-steel",
    cx: "50%",
    cy: "50%",
    r: "75%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0F2F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#06173E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jacket-navy-steel",
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5A6371"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#3B4350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1F2530"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brass-navy-steel",
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E1BC5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8C6E1F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cBlack-navy-steel",
    cx: "30%",
    cy: "30%",
    r: "80%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0A0A0A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cRed-navy-steel",
    cx: "30%",
    cy: "30%",
    r: "80%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF6A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B0231A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cBlue-navy-steel",
    cx: "30%",
    cy: "30%",
    r: "80%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4FA3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0A55BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cWhite-navy-steel",
    cx: "30%",
    cy: "30%",
    r: "80%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C8C8C8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cGreen-navy-steel",
    cx: "30%",
    cy: "30%",
    r: "80%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5FE08A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1B8C36"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "copper-navy-steel",
    cx: "35%",
    cy: "30%",
    r: "80%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FBD8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#C88B45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6E3D14"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    fill: "url(#bg-navy-steel)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 480,
    fill: "url(#jacket-navy-steel)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 420,
    fill: "url(#bg-navy-steel)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 420,
    fill: "url(#brass-navy-steel)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 405,
    fill: "url(#bg-navy-steel)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 130,
    fill: "url(#cGreen-navy-steel)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 65,
    fill: "url(#copper-navy-steel)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 252,
    r: 130,
    fill: "url(#cBlack-navy-steel)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 252,
    r: 65,
    fill: "url(#copper-navy-steel)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 737,
    cy: 382,
    r: 130,
    fill: "url(#cRed-navy-steel)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 737,
    cy: 382,
    r: 65,
    fill: "url(#copper-navy-steel)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 737,
    cy: 642,
    r: 130,
    fill: "url(#cBlue-navy-steel)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 737,
    cy: 642,
    r: 65,
    fill: "url(#copper-navy-steel)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 772,
    r: 130,
    fill: "url(#cWhite-navy-steel)"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 772,
    r: 65,
    fill: "url(#copper-navy-steel)"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 287,
    cy: 642,
    r: 130,
    fill: "url(#cBlack-navy-steel)"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 287,
    cy: 642,
    r: 65,
    fill: "url(#copper-navy-steel)"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 287,
    cy: 382,
    r: 130,
    fill: "url(#cRed-navy-steel)"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 287,
    cy: 382,
    r: 65,
    fill: "url(#copper-navy-steel)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConduitFillIcon);
export default __webpack_public_path__ + "static/media/conduit-fill-icon.23e340a41fb3f6329f161d9bedc21b7f.svg";
export { ForwardRef as ReactComponent };